import { motion, AnimatePresence } from "framer-motion";
import { memo } from "react";
import ReactMarkdown from "react-markdown";
import { ANIMATION_PRESETS, EASING_CURVES, createStaggerDelay } from "../utils/motion";

const Sentence = memo(({ sentence, steps, idx, isVisible, noAnims }) => {
  // Calculate staggered delay using utility function
  const staggerDelay = createStaggerDelay(idx, 0.1, 2); // steps[idx] * 2 equivalent
  const exitDuration = steps[idx] * 0.2;

  if (noAnims) {
    return (
      <p className="text-white lg:text-8xl md:text-7xl text-center font-lexend">
        <ReactMarkdown
          escapeHtml={false}
          components={{
            strong: ({ node, ...props }) => (
              <span className="centered-text" {...props} />
            ),
          }}
        >
          {sentence}
        </ReactMarkdown>
      </p>
    );
  }

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.p
          initial={ANIMATION_PRESETS.fadeInUp.initial}
          animate={{
            opacity: 1,
            y: 0,
            transition: {
              delay: staggerDelay,
              duration: 0.6,
              ease: EASING_CURVES.smooth
            }
          }}
          exit={{
            opacity: 0,
            y: -20,
            transition: {
              duration: exitDuration,
              ease: EASING_CURVES.smooth
            },
          }}
          style={{ willChange: 'transform, opacity' }}
        >
          <ReactMarkdown
            className="text-white lg:text-8xl md:text-7xl text-center"
            escapeHtml={false}
            components={{
              strong: ({ node, ...props }) => (
                <span className="text-strong" {...props} />
              ),
            }}
          >
            {sentence}
          </ReactMarkdown>
        </motion.p>
      )}
    </AnimatePresence>
  );
});

Sentence.displayName = 'Sentence';

export default Sentence;
